import {DeserializedElement, DeserializedElementRule} from "../../slate/Transformation";
import React from "react";

export const Rules: {[key: string]: DeserializedElementRule<HTMLElement>} = {
    "component": {
        tagType: () => 'inline',
        isVoid: () => true,
        match: (element) => element.type === 'component',
        deserialize(el, next)
        {
            if (el.tagName?.toLowerCase() === 'component') {

                const getAttributes = (el): { [key: string]: any } => {
                    return Array.from(el.attributes)
                        .map(a => [a.name, a.value])
                        .reduce((acc, attr) => {
                            acc[attr[0]] = attr[1]
                            return acc
                        }, {})
                }

                let props = getAttributes(el);
                if (props.presetdata) {
                    props.presetdata = JSON.parse(props.presetdata);
                }

                return {
                    type: 'component',
                    props,
                    children: next(el.childNodes)
                } as DeserializedElement;
            }
        },
        serialize(node, next)
        {
            if (node.type === 'component') {
                let props: { [key: string]: any } = {...node.props};
                if (props.presetdata) {
                    props.presetdata = JSON.stringify(props.presetdata);
                }
                return <component {...props}>{next(node.children)}</component>;
            }
        },
        render: ({editor, node}) => {
            if (node.element?.type === 'component') {
                return <span {...node.attributes}>{node.children}</span>;
            }
        }
    },
};